/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Rates_Month_ErrorInputs */

const fr_client_rates_month_error = /** @type {(inputs: Client_Rates_Month_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque période doit durer au moins un mois calendaire.`)
};

const en_client_rates_month_error = /** @type {(inputs: Client_Rates_Month_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each period must last at least one calendar month.`)
};

/**
* | output |
* | --- |
* | "Each period must last at least one calendar month." |
*
* @param {Client_Rates_Month_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const client_rates_month_error = /** @type {((inputs?: Client_Rates_Month_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Rates_Month_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_rates_month_error(inputs)
	return fr_client_rates_month_error(inputs)
});